<div class="container mail-process black-link">
    <div class="row" style="padding: 1em">
        <div
            class="col-md-8 col-sm-12 offset-md-2 offset-sm-0 text-center mb-4"
        >
            <div id="has-driver-log-note-complete" class="text-center">
                <img
                    src="/assets/images/mail-in-process-banner.png"
                    alt="Mailing Issue Header"
                    class="mb-4 img-fluid"
                    style="max-width: 100%"
                />
            </div>

            <div class="delivery-header">
                <h1 class="mt-3 bold">Tablet Shipped</h1>
                <h5 class="mt-3 description">
                    Estimated arrival:
                    <span class="bold">{{ deliveryDate }} </span>
                </h5>
                <img
                    src="/assets/images/mail-in-process-graphic.png"
                    alt="Mailing Issue Graphic"
                    class="mt-4"
                    style="max-width: 100%"
                />
                <p class="mt-4 description-grey">
                    Reminder: A signature is required, so please make sure
                    someone is home to receive the tablet. This screen may show
                    for up to 24 hours after your tablet been delivered.
                </p>
            </div>
            <hr class="mt-4" style="border-top: 2px solid #cccccc" />
            <div class="delivery-header">
                <h2 class="mt-4 bold">Delivery Details</h2>
                <p class="mt-4 description-grey">Shipping Address</p>
                <p class="mt-2 description">{{ address }}</p>
                <p class="mt-4 description-grey">Tracking Number</p>
                <p class="mt-2 tracking_number">
                    <img
                        src="/assets/images/fedex.png"
                        alt="Mail In Process!"
                        class="fedex"
                        style="margin-right: 0.5em"
                    />
                    <a
                        class="text"
                        target="_blank"
                        id="mail-in-process-tracking-link"
                        href="https://www.fedex.com/apps/fedextrack/?tracknumbers={{
                            trackingNumber
                        }}"
                        >{{ trackingNumber }}
                    </a>
                </p>

                <!-- <h3 class="mt-5 bold">Start earning now!</h3>
                <p class="mt-4 description">
                    Earn $25 every time a driver you refer starts driving with
                    the tablet. Share your personal referral code
                    <span class="bold">{{ referral_code }}</span> or your
                    personal link:
                    <a href="{{ referral_link }}" id="mail-in-process-referral-link">{{ referral_link }}</a> today!
                </p> -->
                <span class="mt-4 mb-4"
                    >Questions?
                    <a
                        class="link"
                        target="_blank"
                        href="https://playoctopus.com/help"
                        id="mail-in-process-help-link"
                        >playoctopus.com/help</a
                    ></span
                >
            </div>
        </div>
    </div>
</div>
